export const workConstructor = () => {
  const constructorMethod = (data, commons) => {
    const foo = data?.map((work) => {
      return {
        ...work,
        groupName: commons.groups?.find((group) => group._id === work?.group)
          ?.title,
        userName:
          work.user !== undefined && work.user !== null
            ? `${work.user?.firstName ?? ''} ${work.user?.lastName ?? ''} ${
                work.user?.middleName ?? ''
              }`
            : '',
        categoryName: commons.categories?.find(
          (category) => category._id === work?.category
        )?.title,
        regionName: commons.regions?.find(
          (region) => region._id === work?.region
        )?.title,
        objectName: commons.objects?.find((object) => object._id === work?.mfy)
          ?.title,
        subCategoryName: commons.categories?.find(
          (subCategory) => subCategory._id === work?.subCategory
        )?.title,
      };
    });
    return foo;
  };

  return {
    constructorMethod,
  };
};
